import { Team, TeamFilter } from '@/entities/teams'
import HTTP from '@/plugin/http'
import { toPlainObject } from '@utils'
import TeamsRoute from '../routes/teams'

export async function teamList({ recommend = false, query = '' } = {}) {
  const params = parseQuery(query)
  const data = await HTTP.create('about-us/teams', Team)
    .withParams({
      departmentIds: params.department,
      locationIds: params.location,
      recommend: recommend ? 1 : undefined,
    })
    .json()
  return toPlainObject(data) as unknown as Team[]
}

export function parseQuery(query?: string) {
  const route = new TeamsRoute()
  if (query) {
    route.fromSlug(query)
  }

  let location
  if (route.getVal('location')) {
    location = (route.getVal('location') as string).split('-').pop()
  }
  let department
  if (route.getVal('department')) {
    department = (route.getVal('department') as string).split('-').pop()
  }

  return {
    location,
    department,
  }
}

export async function teamDetail(slug: string) {
  const data = await HTTP.create(`about-us/teams/${slug}`, Team).json()
  return toPlainObject(data)
}

export async function teamsFilter() {
  const data = await HTTP.create('about-us/teams-filters', TeamFilter).json()
  return toPlainObject(data)
}
